import BaseModel from "./baseModel";

export default class ConfigModel extends BaseModel {
  static endPoint = "config/";
}
